{
  "en": {
    "onboardingGroups": {
      "edit": {
        "heading": "Do you already have access to a license group through your institution?",
        "paragraph": "If so, you can activate your access here. You will receive the code from the contact person at your educational institution.",
        "skip": "Continue without code",
        "autoSubmitting": "Activating license …",
        "joined": {
          "title": "You have already joined a license group",
          "next": "Continue",
          "description": "You have been assigned to the school \"{school}\" via the activation code of the group \"{group}\". If you have another code, you can enter it here."
        }
      }
    }
  }
}
